import { fg } from '@atlaskit/platform-feature-flags';

export default {
	get(): boolean {
		return fg('icp_bulk_edit') === true;
	},
};
